import { gql } from '@apollo/client'

export const REMOVE_TEST_MUTATION = gql`
  mutation RemoveTest($id: ID!) {
    removeTest(id: $id)
  }
`
